import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTelephone: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconTelephone"><Path d="M5.5 3C4.11929 3 3 4.11929 3 5.5V6C3 14.2843 9.71573 21 18 21H18.5C19.8807 21 21 19.8807 21 18.5V14.382L15.8025 11.7832L14.2736 13.3122C12.5808 12.5156 11.4844 11.4192 10.6878 9.72645L12.2168 8.19745L9.61803 3H5.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTelephone;
